import React from 'react';

import { StyledTextButton } from '@/shared/components/ui/button/text-button/text-button.styled';
import { TTextButtonProps } from '@/shared/components/ui/button/text-button/text-button.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';

export const TextButton: React.FC<TTextButtonProps> = ({
  variant,
  icon,
  tooltip,
  children,
  clicked,
  ...props
}) => {
  return (
    <Tooltip title={tooltip} wrapper="default">
      <StyledTextButton $variant={variant} $clicked={clicked} {...props}>
        {icon}
        {children}
      </StyledTextButton>
    </Tooltip>
  );
};
